import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

export interface CanisterTypeConfirmDialogData {
	serialNo: string;
	currentText: string;
	nextType: string;
}

@Component({
	selector: 'kt-canister-type-confirm-dialog',
	templateUrl: './canister-type-confirm-dialog.component.html'
})
export class CanisterTypeConfirmDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<CanisterTypeConfirmDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: CanisterTypeConfirmDialogData
	) {}

	onConfirm(): void {
		this.dialogRef.close({ confirmed: true });
	}

	onCancel(): void {
		this.dialogRef.close({ confirmed: false });
	}
}
